import React, { Component } from 'react'
import Navbar from "../CommonComponents/Navbar";
import Footer from "../CommonComponents/Footer";
export class AboutPage extends Component {
    render() {
        return (
            <div>
                <Navbar></Navbar>
                <div>
                    About page
                </div>
                <Footer></Footer>
            </div>
        )
    }
}

export default AboutPage
